import { Modal as MUIModal, Stack } from '@mui/material';
import styled from 'styled-components';

export const Modal = styled(MUIModal)`
  && {
    & .MuiBackdrop-root {
      background-color: ${({ theme }) => theme.palette.background.overlay};
    }
  }
`;

export const ModalContainer = styled(Stack)`
  && {
    position: absolute;
    display: flex;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    padding: 2.5rem;
    min-width: 440px;
    background: ${({ theme }) => theme.palette.background.paper};
    border-radius: ${({ theme }) => theme.shape.modalRadius};
    max-height: calc(100vh - 4rem);
    overflow-y: scroll;
  }
`;
